<template>
  <UnopenedLeadCard 
    @close="close"
    @open="open"
    :lead="lead"
  >    
    <div><strong>Yes I want this lead!</strong></div>

    <div class="mt-5">You will be charged {{ $formatters.currency(lead.price_cents) }} <em>(plus tax)</em>.</div>

    <div class="mt-5">
      We're big on sharing the success. That's why most of what we collect goes
      directly to the person who created this lead. It's our way of making
      sure everyone wins!
    </div>
  </UnopenedLeadCard>
</template>

<script>
import UnopenedLeadCard from './UnopenedLeadCard.vue'

export default {
  name: 'UnopenedLeadSufficient',

  components: { UnopenedLeadCard },

  props: {
    lead: {
      type: Object,
      required: true,
    },
  },

  methods: {
    close() {
      this.$emit('close')
    },

    open() {
      this.$router.push( { name: 'leads', params: { lead_id: this.lead.lead_id }})
    },
  }
}
</script>